export function stringToNumberArray(value?: string): number[] {
    if (!value) {
        return [];
    }
    return value.split(",").map(Number);
}
